module.exports = __webpack_public_path__ + "img/DSC00521.ad530eee.JPG";